import { Select, Store } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { LoginState } from './login.state';
import { Observable } from 'rxjs';
import { LoginScreen } from '../services/models/login-screen.model';
import {
  ChangeScreen,
  CloseDialog, ExternalLogin,
  ChangeLastScreen,
  Login,
  RecoverPassword, Signup,
  ValidateCode,
  VerifyReCaptcha,
} from './login.actions';
import { LoginRequest } from '../services/models/login.request';
import { LoginService } from '../services/login.service';
import { SignupStatus } from '../services/models/signup.response';

@Injectable({
  providedIn: 'root',
})
export class LoginFacade {
  private readonly store = inject(Store);
  private readonly loginService = inject(LoginService);

  @Select(LoginState.open) open$: Observable<boolean>;
  @Select(LoginState.screen) screen$: Observable<LoginScreen>;
  @Select(LoginState.lastScreen) lastScreen$: Observable<LoginScreen>;
  @Select(LoginState.reCaptchaResponse) reCaptchaResponse$: Observable<boolean | null>;
  @Select(LoginState.recoverPasswordResponse) recoverPasswordResponse$: Observable<boolean | null>;
  @Select(LoginState.loginAttempts) loginAttempts$: Observable<number>;
  @Select(LoginState.signupStatus) signupStatus$: Observable<SignupStatus | null>;
  @Select(LoginState.isAuthenticated) isAuthenticated$: Observable<boolean>;

  get isAuthenticated() {
    return this.store.selectSnapshot(LoginState.isAuthenticated);
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }
  /**
   * Changes login modal screen. The final screen may differ from the desired based on its own logic.
   * @see LoginState#changeScreen
   */
  changeScreen(screen: LoginScreen) {
    this.store.dispatch(new ChangeScreen(screen));
  }

  changeLastScreen(screen: LoginScreen | string) {
    this.store.dispatch(new ChangeLastScreen(screen));
  }

  verifyReCaptcha(token: string) {
    this.store.dispatch(new VerifyReCaptcha(token));
  }

  recoverPassword(identifier: string) {
    this.store.dispatch(new RecoverPassword(identifier));
  }

  login(request: LoginRequest) {
    return this.store.dispatch(new Login(request));
  }

  validateCode(code: string) {
    this.store.dispatch(new ValidateCode(code));
  }

  getRutInfo(rut: string, multipleId: number) {
    return this.loginService.getRutInfo(rut, multipleId);
  }

  signup(formModel: unknown, multipleId: number) {
    return this.store.dispatch(new Signup(formModel, multipleId));
  }

  externalLogin(url: string) {
    return this.store.dispatch(new ExternalLogin(url));
  }
}
